import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';
import { CustomTooltipModule } from '@principle-theorem/ng-shared';
import { IMarketingCampaignStepSummary } from './campaign-step-summary';

@Component({
  selector: 'pr-campaign-steps-summary',
  templateUrl: './campaign-steps-summary.component.html',
  styleUrl: './campaign-steps-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline' },
  imports: [CustomTooltipModule],
})
export class CampaignStepsSummaryComponent {
  stepSummary = input.required<IMarketingCampaignStepSummary>();
  stepCount: Signal<number>;
  totalDuration: Signal<number>;

  constructor() {
    this.stepCount = computed(() => {
      return this.stepSummary().activeSteps;
    });
    this.totalDuration = computed(() => {
      return this.stepSummary().durationInDays;
    });
  }
}
